import React from 'react';
import {
    Scissors, Target, TriangleRight, Waypoints, Maximize, Circle, Redo,
    Square, Box, Mountain, MessageSquare, Cloud, Camera, HelpCircle, Ruler,
    CircleSmall, CircleGauge, Rotate3D,
    Disc,
    Torus
} from 'lucide-react';

// This map defines the icon and Potree tool name for each of our tools.
// This is the single source of truth for icons and names.
export const TOOL_MAP = {
    POINT: { name: 'Point', icon: <CircleSmall size={22} />, potreeName: 'Point measurement', i18n: '[title]tt.point_measurement' },
    DISTANCE: { name: 'Distance', icon: <Waypoints size={22} />, potreeName: 'Distance measurement', i18n: '[title]tt.distance_measurement' },
    HEIGHT: { name: 'Height', icon: <Ruler size={22} />, potreeName: 'Height measurement', i18n: '[title]tt.height_measurement' },
    ANGLE: { name: 'Angle', icon: <TriangleRight size={22} />, potreeName: 'Angle measurement', i18n: '[title]tt.angle_measurement' },
    CIRCLE: { name: 'Circle', icon: <Disc size={22} />, potreeName: 'Circle measurement', i18n: '[title]tt.circle_measurement' },
    AZIMUTH: { name: 'Azimuth', icon: <CircleGauge size={22} />, potreeName: 'Azimuth', i18n: '[title]tt.azimuth_measurement' },
    AREA: { name: 'Area', icon: <Square size={22} />, potreeName: 'Area measurement', i18n: '[title]tt.area_measurement' },
    VOLUME: { name: 'Volume', icon: <Box size={22} />, potreeName: 'Volume clip', i18n: '[title]tt.clip_volume' },
    SPHERE: { name: 'Sphere', icon: <Torus size={22} />, potreeName: 'Sphere measurement', i18n: '[title]tt.sphere_measurement' },
    PROFILE: { name: 'Profile', icon: <Mountain size={22} />, potreeName: 'Height profile', i18n: '[title]tt.height_profile' },
    ANNOTATION: { name: 'Annotation', icon: <MessageSquare size={22} />, potreeName: 'Annotation', i18n: '[title]tt.annotation' },
};

// This map helps the outliner find the right icon based on the object's properties.
export const getIconForOutlinerObject = (object) => {
    // 1. Handle special cases by constructor name first, as these are unique.
    switch (object.constructor.name) {
        case 'PointCloudOctree': return <Cloud size={22} />;
        case 'Annotation': return <MessageSquare size={22} />;
        case 'PerspectiveCamera': return <Camera size={22} />;
    }

    if (object.sphere) {
        return TOOL_MAP.SPHERE.icon;
    }

    // 2. For everything else, use a switch on the object's `name` property.
    // This is reliable because the name is set consistently by Potree's tools.
    // We clone the icon from our TOOL_MAP to resize it.
    switch (object.name) {
        case 'Point':
            return TOOL_MAP.POINT.icon;
        case 'Angle':
            return TOOL_MAP.ANGLE.icon;
        case 'Distance':
            return TOOL_MAP.DISTANCE.icon;
        case 'Height':
            return TOOL_MAP.HEIGHT.icon;
        case 'Circle':
            return TOOL_MAP.CIRCLE.icon;
        case 'Area':
            return TOOL_MAP.AREA.icon;
        case 'Volume':
            return TOOL_MAP.VOLUME.icon;
        case 'Sphere':
            return TOOL_MAP.SPHERE.icon;
        case 'Profile':
            return TOOL_MAP.PROFILE.icon;
        case 'Azimuth':
            return TOOL_MAP.AZIMUTH.icon;
    }

    console.log('Object: ', object);

    // 3. Final fallback for any other object types (like SphereVolume, BoxVolume).
    if (object.constructor.name.includes('Volume')) {
        return <Box size={22} />;
    }

    return <HelpCircle size={22} />;
};